import { WAGEN_GROOTTE } from "../constants";

export function getPlanningCapacity(capacity, wagonSize = WAGEN_GROOTTE) {
  const physicalCapacity = Number(capacity || 0);
  const cratesPerWagon = Number(wagonSize || 0);

  if (physicalCapacity <= 0 || cratesPerWagon <= 0) {
    return Math.max(0, physicalCapacity);
  }

  const fullWagons = Math.floor(physicalCapacity / cratesPerWagon);
  return fullWagons > 0 ? fullWagons * cratesPerWagon : physicalCapacity;
}

export function hasReachedPlanningCapacity(row) {
  const occupied = Number(row?.huidige_bezetting || 0);
  const planningCapacity = getPlanningCapacity(row?.capaciteit);
  return planningCapacity > 0 && occupied >= planningCapacity;
}
